import { Injectable } from '@angular/core';

import { AbstractAsyncTaskReport } from './abstract-async-task.report';
import { ITask } from './async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class CatoNetworkDeviceBulkDeleteReport extends AbstractAsyncTaskReport {
  public generate(task: ITask): string {
    const detail = task.detail;
    let htmlDetail: string = '';
    if (task.status === 'success') {
      htmlDetail += `<div>Tous les workflows pour les équipements réseaux de type Cato ont été rejoué avec succès : <br></div> ${this.formatLinkList('network-devices', detail.inactive_devices)}`;
    }else {
      htmlDetail += `<div>Erreur lors du replay des workflows pour les équipements réseaux de type Cato: <br></div> ${this.formatLinkList('network-devices', detail.network_devices)}`;
    }
    return htmlDetail;
  }
}
